import { render, staticRenderFns } from "./Masters.vue?vue&type=template&id=66aa4f96"
import script from "./Masters.vue?vue&type=script&lang=js"
export * from "./Masters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports